const ButtonDownload = ()=>{
    return (
        <button type="button" className="w-full flex items-center justify-center rounded py-2 px-4 text-sm font-medium text-white bg-gray-800 hover:bg-gray-700 shadow-lg transition duration-200">
            <span className="material-icons mr-2">download</span> Exportar
        </button>
    );
};

export default ButtonDownload;